export default __webpack_public_path__ + "static/media/open_purchase.9dd76cfd.mp3";